import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  FormHelperText
} from "@mui/material";
import SubmissionStatusModal from "../../../components/popup-modal/submitStatusModal";
import ClientAPI from "../../../api/clientApi";

const AddMoreAppsModal = ({
  isOpen,
  onClose,
  subscriptionData,
  afterSubmit,
}) => {
  const [numApps, setNumApps] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    //fetching subcription data
    if (isOpen && subscriptionData) {
      setNumApps(subscriptionData.numApps || "");
      setError("");
    }
  }, [isOpen, subscriptionData]);

  const handleSubmit = async () => {
    if (!numApps) {
      setError("This field is required");
      return;
    }
    if (!subscriptionData || !subscriptionData.id) {
      subscriptionData = subscriptionData || {};
      subscriptionData.id = 1;
    }
    const applicationData = {
      id: subscriptionData.id,
      totalNoOfApplication: numApps,
    };
    try {
      setIsSubmitting(true);
      const result = await ClientAPI.updateSubscriptionApplicationCount(applicationData);
      let successMessage =
        result.message === "No response body was returned."
          ? "Application count updated successfully"
          : result.message || "Application count updated successfully";
      setIsSuccess(true);
      setMessage(successMessage);
      afterSubmit();
      setNumApps("");
      if (result.statusCode==="FAILED"){
        setIsSuccess(false);
      setMessage(result.message);

      }
    } catch (error) {
      setIsSuccess(false);
      setMessage(error.message || "Failed to update application count");
      setError("");
      setNumApps("");
    } finally {
      setIsSubmitting(false);
      setModalOpen(true);
    }
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    onClose();
  };
  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };
  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth>
      <DialogTitle>
        <Typography variant="h6" align="center" style={{ color: "red" }}>
          Add More Applications
        </Typography>
      </DialogTitle>
      <DialogContent>
        {/* <form onSubmit={handleSubmit}> */}
        <TextField
          margin="normal"
          fullWidth
          id="numApps"
          label="Number of Applications"
          variant="outlined"
          value={numApps}
          onChange={(e) => {
            const value = e.target.value;
            if (
              /^\d*$/.test(value) &&
              (value === "" || value[0] !== "0") &&
              value.length <= 10
            ) {
              setNumApps(value);
              setError(""); // Clear error on valid input
            } else if (value[0] === "0") {
              setError("Value cannot start with 0");
            }
          }}
          onKeyDown={(e) => {
            // Prevent 'e', 'E', '+', '-', '.' and prevent '0' as the first character
            if (
              ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(
                e.key
              ) ||
              (e.key === "0" && numApps === "")
            ) {
              e.preventDefault();
            }
          }}
          inputProps={{
            inputMode: "numeric", // Ensures numeric keyboard on mobile
            pattern: "[1-9][0-9]*", // Ensures valid positive numbers
          }}
          required
          error={!!error}
          helperText={error} 
        />
         <FormHelperText style={{ color: "#666", marginLeft: "10px" }}>
          How many Applications do you want to add?
        </FormHelperText>
        <DialogActions>
          <Button
            onClick={() => {
              onClose();
              setError("");
              setNumApps("");
            }}
            style={{ color: "red" }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            style={{ backgroundColor: "red", color: "white" }}
            variant="contained"
            disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </DialogActions>
        {/* </form> */}
      </DialogContent>
      <SubmissionStatusModal
        open={modalOpen}
        onClose={handleCloseModal}
        isSuccess={isSuccess}
        message={message}
      />
    </Dialog>
  );
};

export default AddMoreAppsModal;
